import ImageGalleryFullscreenButton from './ImageGalleryFullscreenButton';

export default ImageGalleryFullscreenButton;
